import React from 'react'
import PropTypes from 'prop-types'
import {
  Container,
  Grid,
  Image,
  Segment,
  Icon,
  Message
} from 'semantic-ui-react'

const propTypes = {
  siteLabel: PropTypes.string.isRequired,
  copyrightYear: PropTypes.number.isRequired,
  siteLogoUrl: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  email: PropTypes.string,
  phone: PropTypes.string,
  socialMediaLinks: PropTypes.array
}

const PageMainFooter = props => {
  const { siteLabel, siteLogoUrl, copyrightYear, message, socialMediaLinks, email, phone } = props
  const renderSocialMediaLinks = links => {
    return links.filter((link) => {
      return link.active
    }).map((url) => {
      return (
        <a href={url.url} key={url.id} target="_blank">
          <Icon name={url.icon} size='big'/>
        </a>
      )
    })
  }
  return (
    <Segment
      inverted
      vertical
      style={{ margin: '5em 0em 0em', padding: '5em 0em' }}
    >
      <Container textAlign="center">
        <Grid inverted stackable>
          <Grid.Row>
            <Grid.Column computer={8} tablet={8} mobile={16} align="center">

              <div id="Table_01">
                <div id="barve-01_"> <a href="http://www.jub.si/"><img id="barve_01" src="img/barve_01.png" width="112" height="71" alt="" /></a>
                </div>
                <div id="barve-02_"> <a href="http://www.helios.si/slo"><img id="barve_02" src="img/barve_02.png" width="70" height="71" alt="" /></a>
                </div>
                <div id="barve-03_"> <a href="http://www.remmers.de/"><img id="barve_03" src="img/barve_03.png" width="118" height="71" alt="" /></a>
                </div>
                <div id="barve-04_"> <a href="http://www.color.si/"><img id="barve_04" src="img/barve_04.png" width="112" height="65" alt="" /></a>
                </div>
                <div id="barve-05_"> <a href="http://www.baumit.si/"><img id="barve_05" src="img/barve_05.png" width="70" height="65" alt="" /></a>
                </div>
                <div id="barve-06_"> <a href="http://www.novolit.si/"><img id="barve_06" src="img/barve_06.png" width="118" height="65" alt="" /></a>
                </div>
                <div id="barve-07_"> <a href="http://www.candis.it/en/index.php"><img id="barve_07" src="img/barve_07.png" width="112" height="54" alt="" /></a>
                </div>
                <div id="barve-08_"> <a href="http://www.caparol.si/"><img id="barve_08" src="img/barve_08.png" width="70" height="54" alt="" /></a>
                </div>
                <div id="barve-09_"> <a href="http://www.valpaint.it/"><img id="barve_09" src="img/barve_09.png" width="118" height="54" alt="" /></a>
                </div>
                <div id="barve-10_"> <a href="http://www.roefix.com/ROEFIX-Slovenija.265.8.html"><img id="barve_10" src="img/barve_10.png" width="112" height="70" alt="" /></a>
                </div>
                <div id="barve-11_"> <a href="http://www.sigmacoatings.si"><img id="barve_11" src="img/barve_11.png" width="70" height="70" alt="" /></a>
                </div>
                <div id="barve-12_"> <a href="http://www.sikkens.com"><img id="barve_12" src="img/barve_12.png" width="118" height="70" alt="" /></a>
                </div>
              </div>
            </Grid.Column>
            <Grid.Column computer={8} tablet={8} mobile={16} align="center">

              <div id="Table_01">
                <div id="materiali-01_"> <a href="http://www.proform.si/"><img id="materiali_01" src="img/materiali_01.png" width="107" height="79" alt="" /></a>
                </div>
                <div id="materiali-02_"> <a href="http://www.isover.si/"><img id="materiali_02" src="img/materiali_02.png" width="80" height="79" alt="" /></a>
                </div>
                <div id="materiali-03_"> <a href="http://www.domtrade.si/"><img id="materiali_03" src="img/materiali_03.png" width="113" height="79" alt="" /></a>
                </div>
                <div id="materiali-04_"> <a href="http://www.knaufinsulation.si/"><img id="materiali_04" src="img/materiali_04.png" width="107" height="48" alt="" /></a>
                </div>
                <div id="materiali-05_"> <a href="http://www.ursa.si/"><img id="materiali_05" src="img/materiali_05.png" width="80" height="48" alt="" /></a>
                </div>
                <div id="materiali-06_"> <a href="http://www.amfceilings.co.uk/"><img id="materiali_06" src="img/materiali_06.png" width="113" height="48" alt="" /></a>
                </div>
                <div id="materiali-07_"> <a href="http://www.solatube.si/"><img id="materiali_07" src="img/materiali_07.png" width="107" height="38" alt="" /></a>
                </div>
                <div id="materiali-08_"> <a href="http://si.rigips.at/"><img id="materiali_08" src="img/materiali_08.png" width="80" height="38" alt="" /></a>
                </div>
                <div id="materiali-09_"> <a href="https://www.fermacell.si/"><img id="materiali_09" src="img/materiali_09.png" width="113" height="38" alt="" /></a>
                </div>
                <div id="materiali-10_"> <a href="http://www.armstrong.si/"><img id="materiali_10" src="img/materiali_10.png" width="107" height="35" alt="" /></a>
                </div>
                <div id="materiali-11_">
                  <a href="http://www.ekoprodukt.si"><img id="materiali_11" src="img/materiali_11.png" width="80" height="35" alt="" /></a>
                </div>
                <div id="materiali-12_"> <a href="http://www.agepan.de/"><img id="materiali_12" src="img/materiali_12.png" width="113" height="35" alt="" /></a>
                </div>
                <div id="materiali-13_"> <a href="http://www.objectflor.de"><img id="materiali_13" src="img/materiali_13.png" width="107" height="60" alt="" /></a>
                </div>
                <div id="materiali-14_"> <a href="http://de.wedi.de/"><img id="materiali_14" src="img/materiali_14.png" width="80" height="60" alt="" /></a>
                </div>
                <div id="materiali-15_"> <a href="http://steico.si/"><img id="materiali_15" src="img/materiali_15.png" width="113" height="60" alt="" /></a>
                </div>
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              {siteLabel} - {copyrightYear}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              {renderSocialMediaLinks(socialMediaLinks)}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>
  )
}

PageMainFooter.propTypes = propTypes
export default PageMainFooter



// WEBPACK FOOTER //
// ./src/components/PageMainFooter.js